import styled, { css } from 'styled-components';

import { flexAsColumn, grid } from '@components/Styled/mixins';

// Medium and large variant not yet defined
// This measures are according to the design system, except for the full size
const DESKTOP_DRAWER_SIZES = {
  small: 45,
  medium: 60,
  large: 80,
  full: 100
};

const getDesktopDrawerWidth = (theme, size) => {
  if (size === 'full') return `${DESKTOP_DRAWER_SIZES[size]}vw`;

  return theme.spacing(DESKTOP_DRAWER_SIZES[size]);
};

const Backdrop = styled.aside`
  ${grid()};

  height: 100vh;
  width: 100vw;
  justify-content: end;
  position: fixed;
  inset: 0;
  transition: background-color 0.7s ease-in-out;
  z-index: ${({ theme }) => theme.zIndex.modal};
  pointer-events: none;

  ${({ isOpen, theme }) => Boolean(isOpen) && css`
    background-color: rgba(${theme.getRgbColor(theme.palette.grayJ)}, 0.6);
    pointer-events: initial;
  `};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}px) {
    align-items: end;
  }
`;

const DrawerWrapper = styled.nav`
  ${flexAsColumn()};

  height: 100vh;
  width: 100vw;
  background-color: ${({ theme }) => theme.colors.secondary.lighterBlue};
  grid-template-rows: auto;
  transition: transform 0.7s ease-in-out;

  ${({ isOpen }) => Boolean(!isOpen) && css`
    transform: translateY(100vh);
  `};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}px) {
    ${({ isOpen, size, theme }) => {
    const drawerWitdh = getDesktopDrawerWidth(theme, size);

    return css`
      width: ${drawerWitdh};
      transform: translateX(${isOpen ? 0 : drawerWitdh});
    `;
  }
}}`;

export { Backdrop, DrawerWrapper };
